<template>
  <div class="pfslide">
    <div class="pfslide__title" v-html="title"></div>
    <div class="pfslide__thincontent pfslide__thincontent_sl0">
      <TextInput text='ФИО' name='fullname' v-model="client.fullname" :validation="(v) => v ? ((v.split(' ').length < 3) ? 'Заполните поле' : '') : ''" :options="fullnameSuggest" :blurcondition="client.fullname.split(' ').length >= 3" :selectonly="true" />
      <DateInput text='Дата рождения' name='birthdate' v-model="client.birthdate" :validation="isValidBirthdate" />
      <NumberInput text='Номер телефона' name='tel' type='tel' :filled="(v) => v.length == 18" mask='+7 (###) ###-##-##' v-model="client.tel" />
      <EmailInput text='E-mail' name='email' v-model="client.email" />
      <CheckBox :smtext="true" :tostart="true" name="agreement" v-model="client.agreement">
        Я ознакомился с <a class="pfslide-newred" href="./" target="_blank">политикой обработки</a> персональных данных (ПД) и даю согласие на <a class="pfslide-newred" href='./' target="_blank">обработку ПД</a>.
      </CheckBox>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import slide from '../../mixins/slide.vue'
import TextInput from '../inputs/TextInput.vue'
import DateInput from '../inputs/DateInput.vue'
import EmailInput from '../inputs/EmailInput.vue'
import CheckBox from '../inputs/CheckBox.vue'
import NumberInput from '../inputs/NumberInput.vue'

export default {
  name: "slide0",
  data: () => ({
    fullnameSuggest: []
  }),
  mixins: [slide],
  components: { TextInput, DateInput, EmailInput, NumberInput, CheckBox },
  computed: {
    ...mapState(['DaData'])
  },
  methods: {
    isValidBirthdate(date) {
      if (!date)
        return ''
      if (Date.now() - date < 0)
        return 'Указана дата из будущего'
      let y = new Date().getFullYear(),
        m = new Date().getMonth(),
        d = new Date().getDate()
      if (date >= new Date(y - 18, m, d))
        return 'Не менее 18 лет'
      if (date < new Date(y - 100, m, d))
        return 'Не более 100 лет'
      return ''
    },
  },
  watch: {
    async 'client.fullname'(val) {
      let url = this.DaData.urls.FIO,
        token = this.DaData.token,
        query = val,
        gender = 'UNKNOWN'
      switch (this.client.sex) {
        case 'Мужской':
          gender = 'MALE'
          break
        case 'Женский':
          gender = 'FEMALE'
      }
      let options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Token " + token
        },
        body: JSON.stringify({ query, gender, count: 5 })
      }

      let sg = await (fetch(url, options)
        .then(response => response.json())
        .then(res => { return res.suggestions.map(el => ((el.data.surname || '') + ' ' + (el.data.name || '') + ' ' + (el.data.patronymic || '')).replace(/\s+/g, ' ').trim()) })
        .catch(() => []))

      this.fullnameSuggest = sg
    }
  }
}
</script>

<style lang="sass" scoped>

</style>